import React from 'react';
import { Modal } from '@appkit4/react-components/modal';
import { Progress } from '@appkit4/react-components/progress';
import './UploadingDocumentsModal.scss';
import UploadingDocs from '../../../assets/illustrations/uploading-docs.png';

interface UploadingDocumentsModalProps {
    uploadProgress: number;
    visible: boolean;
    fileString: Array<string>;
    files: File[];
}

const UploadingDocumentsModal: React.FC<UploadingDocumentsModalProps> = ({
    uploadProgress,
    visible,
    fileString,
    files,
}) => {
    return (
        <Modal
            visible={visible}
            title="Uploading Documents"
            closable={false}
            className="uploading-modal"
            modalStyle={{ width: '33.75rem' }}
        >
            <div className="row">
                <div className="col-12 d-flex mb-5 mt-5">
                    <img
                        src={UploadingDocs}
                        className="mx-auto"
                        alt="Uploading Documents"
                    />
                </div>
                <div className="col-10 d-flex">
                    <Progress
                        className="progress-bar-doc"
                        activeIndex={uploadProgress}
                        steps={fileString}
                        space={120}
                        orientation="horizontal"
                        readonly={false}
                    ></Progress>
                </div>
                <div className="col-2 d-flex">
                    {Math.floor((uploadProgress / files.length) * 100)}%
                </div>
            </div>
        </Modal>
    );
};

export default UploadingDocumentsModal;
